import { Dispatch } from "@reduxjs/toolkit";
import {
  setContactSales,
  setContactUs,
  setFooter,
  setHelpUsGrow,
  setTermsAndConditions,
} from "./reducer";
import {
  CmsBlocksDataState,
  CmsPageItem,
} from "../../utils/interfaces/cmsBlock";

export const cmsBlockActionDispatch = (dispatch: Dispatch) => ({
  setFooter: (cmsBlock: CmsBlocksDataState) => dispatch(setFooter(cmsBlock)),
  setContactUs: (cmsBlock: CmsBlocksDataState) =>
    dispatch(setContactUs(cmsBlock)),
  setContactSales: (cmsBlock: CmsBlocksDataState) =>
    dispatch(setContactSales(cmsBlock)),
  setHelpUsGrow: (cmsBlock: CmsBlocksDataState) =>
    dispatch(setHelpUsGrow(cmsBlock)),
  setTermsAndConditions: (cmsPage: CmsPageItem) =>
    dispatch(setTermsAndConditions(cmsPage)),
});
